<template>
<v-flex fill fill-height horizontal>
    <div class="text-xs-center" v-if="loading">
        <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
        ></v-progress-circular>
    </div>
    <div v-else class="header-section">
        <h1>{{season.name}} Hole Stats</h1>
    </div>
    <section class="elavation-1">
        <v-layout wrap>
            <v-flex md6 sm12 xs12 px-2 py-2 v-for="hole in holes" v-bind:key="seasonId.toString() + hole.hole">
                <v-card class="hole-chart">
                    <v-card-title>
                        <v-layout>
                            <v-flex xs6>
                                <h3>Hole {{hole.hole}} <span v-if="hole.scores[1] > 0">&nbsp;(Aced!)</span></h3>
                            </v-flex>
                            <v-flex xs6 text-xs-right class="caption">
                                <span>Avg: {{getHoleAvg(hole).holeAvg}}</span>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text px-0>
                        <hole-chart :hole="hole" :title="`Avg: ${getHoleAvg(hole).holeAvg}`"></hole-chart>
                    </v-card-text>
                </v-card>

            </v-flex>
        </v-layout>
    </section>
</v-flex>
</template>

<script>
  import HoleChart from './shared/HoleChart';

  export default {
    name: "HoleSummary",
    props: ['seasonId', 'seasonName'],
    components: {
      HoleChart
    },
    data() {
      return {
        loading: false,
        divisions: null,
        error: null,
        season: null,
        holes: []
      }
    },
    methods: {
      async fetchData() {
        this.error = this.divisions = null;
        this.loading = true;
        try {
          const results = await Promise.all([
            this.$apiClient.seasons(this.seasonId),
            this.$apiClient.holes(this.seasonId)
          ]);

          this.season = results[0].data;
          this.holes = results[1].data;
        } catch (e) {
          this.error = e;
        }

        this.loading = false;
      },
      getHoleAvg(hole) {
        const mathAndThings = Object.keys(hole.scores).reduce((result, key) => {
          result.totalStrokes += parseInt(key) * hole.scores[key];
          result.sum += hole.scores[key];
          return result;
        }, {totalStrokes: 0, sum: 0})

        mathAndThings.holeAvg = (mathAndThings.totalStrokes / mathAndThings.sum).toFixed(2);

        return mathAndThings;
      }
    },
    watch: {
      '$route': 'fetchData'
    },
    created() {
      this.fetchData();
    }
  }
</script>

<style>
/*.hole-chart .v-card__text {*/
/*    padding: 0;*/
/*}*/
</style>
